<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="parentId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="romModel" placeholder="设备型号" clearable>
          <el-option
            v-for="item in typeSelect"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select-tree
          :options="categorySelect"
          placeholder="请选择设备分类"
          width="100%"
          :treeProps="treeProps"
          @handleNodeClick="selectDrop"
        />
      </el-col>
      <el-col :span="4">
        <el-input placeholder="机构名称" v-model="insId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table
      :data="data"
      border
      stripe
      row-key="id"
      default-expand-all
      style="width: 100%"
      lazy
      :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChild' }"
    >
      <el-table-column prop="insId" label="机构名称"> </el-table-column>
      <el-table-column prop="devId" label="设备编号"> </el-table-column>
      <el-table-column prop="machineModel" label="设备型号"> </el-table-column>
      <el-table-column prop="categoryName" label="设备分类"> </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getInsList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import elSelectTree from "../../../../components/SelectTree.vue";
var attributes = {
  //定义数据属性名称
  id: "id",
  parentId: "parentId",
  name: "categoryName",
  rootId: 0,
};
export default {
  name: "node",
  data() {
    return {
      parentId: "",
      romModel: "",
      categoryName: "",
      insId: "",
      data: [],
      typeSelect: [],
      categorySelect: [],
      originSelect: [],
      treeProps: {
        value: "id",
        children: "children",
        label: "label",
      },
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  mounted() {
    this.getCategory();
    this.$http
      .post("/manage/machine/page", {
        pageNum: 1,
        pageSize: 99999,
      })
      .then((results) => {
        const filterValue = results["data"]["data"]["records"].map((i) => {
          return {
            value: i.model,
            label: i.model,
          };
        });
        this.typeSelect = filterValue;
      });
  },
  methods: {
    selectDrop(val) {
      console.log("选中---->", val);
      this.categoryName = val;
    },
    load(tree, treeNode, resolve) {
      console.log(tree, "tree");
      if (tree.insId) {
        this.$http
          .post(`/manage/routing-bind/queryTopList`, {
            insId: tree.id,
            syncFlag: true,
            pageNum: 1,
            pageSize: 999,
          })
          .then((results) => {
            const res = results["data"]["data"]["records"].map((i) => {
              i.devId = i.parentId;
              i.id = i.parentId;
              return i;
            });
            resolve(res);
          });
      } else {
        setTimeout(() => {
          const val = tree.childList.map((i) => {
            delete i.insId;
            i.devId = i.childId;
            return i;
          });
          resolve(val);
        }, 1000);
      }
      //   else {
      //   this.$http.post("/manage/routing-bind/by-parent", tree).then((results) => {
      //     const value = results["data"]["data"].map(i => {
      //       delete i.insId;
      //       i.devId = i.childId;
      //       return i;
      //     });
      //     resolve(value);
      //   });
      // }
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getInsList();
    },
    getCategory() {
      //数据绑定
      let params = {
        pageNum: 1,
        pageSize: 20,
      };
      this.$http.post("/manage/category/page", params).then((results) => {
        const value = results["data"]["data"]["records"];
        this.originSelect = [...value];
        this.categorySelect = this.tree([...value], attributes);
      });
    },
    getInsList() {
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.parentId.trim() != "") {
        params.deviceId = this.parentId;
      }
      if (this.insId.trim() != "") {
        params.insName = this.insId;
      }
      if (this.romModel.trim() != "") {
        params.machineModel = this.romModel;
      }
      if (this.categoryName) {
        params.categoryId = this.categoryName.id;
      }
      this.$http
        .post(`/manage/routing-bind/queryInstitutionExsitList`, params)
        .then((results) => {
          const res = results["data"]["data"]["records"];
          this.data = res
            .filter((i) => Boolean(i))
            .map((i) => {
              return {
                id: i.id,
                insId: i.name,
                hasChild: true,
              };
            });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getList() {
      //数据绑定
      let params = {
        syncFlag: true,
      };
      if (this.parentId.trim() != "") {
        params.parentId = this.parentId;
      }
      if (this.insId.trim() != "") {
        params.insId = this.insId;
      }
      if (this.romModel.trim() != "") {
        params.romModel = this.romModel;
      }
      if (this.categoryName) {
        params.categoryName = this.categoryName.id;
      }
      this.$http
        .post(`/manage/routing-bind/queryTopList`, params)
        .then((results) => {
          const res = results["data"]["data"]["records"].map((i) => {
            i.devId = i.parentId;
            i.id = i.parentId;
            return i;
          });
          this.data = res;
        });
    },
    tree(data, attributes) {
      let resData = data;
      let tree = [];
      for (let i = 0; i < resData.length; i++) {
        if (resData[i][attributes.parentId] === attributes.rootId) {
          let obj = {
            id: resData[i][attributes.id],
            label: resData[i][attributes.name],
            data: resData[i],
            children: [],
          };
          if (resData[i].categoryPrefix && resData[i].categoryCode) {
            obj.label = `${obj.label}${resData[i].categoryPrefix}${resData[i].categoryCode}`;
          }
          tree.push(obj);
          resData.splice(i, 1);
          i--;
        }
      }
      run(tree);

      function run(chiArr) {
        if (resData.length !== 0) {
          for (let i = 0; i < chiArr.length; i++) {
            for (let j = 0; j < resData.length; j++) {
              if (chiArr[i].id == resData[j][attributes.parentId]) {
                let obj = {
                  id: resData[j][attributes.id],
                  label: resData[j][attributes.name],
                  children: [],
                  data: resData[j],
                };
                if (resData[j].categoryPrefix && resData[j].categoryCode) {
                  obj.label = `${obj.label}${resData[j].categoryPrefix}${resData[j].categoryCode}`;
                }
                chiArr[i].children.push(obj);
                resData.splice(j, 1);
                j--;
              }
            }
            run(chiArr[i].children);
          }
        }
      }
      return tree;
    },
  },
  components: { Pagination, elSelectTree },
};
</script>
